// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"ffbcd4d7","393":"4211a683"}[chunkId] + ".css";
};